module.exports = __webpack_public_path__ + "static/gradientTwo-ed76cec5b87f63c788f7ba7fcfa7ae48.svg";